import React, { useState, useEffect, useCallback } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { BsFillCaretUpFill, BsFillCaretDownFill } from "react-icons/bs";

const MaterialUiTable = ({
  columns = [],
  data = [],
  fixedHeader = false,
  loading = false,
  tableId = "ma-ui",
  noDataCellCustomStyle = {},
  tableClassName = "",
  containerHeight = null
}) => {
  const [sortedColumn, setSortedColumn] = useState(null);
  const [rowData, setRowData] = useState(data);

  useEffect(()=> {
    if (columns && columns.length) {
      const defaultSortColumn = columns.find((column)=> column.defaultSorted);
      setSortedColumn(defaultSortColumn ? {...defaultSortColumn, sorted: defaultSortColumn.defaultSorted} : null)
    }
  }, []);
  
  useEffect(() => {
    if (data && data.length) {
      if (sortedColumn && sortedColumn.key) {
        const clonedData = JSON.parse(JSON.stringify(data))
        const sortedData = clonedData.sort((a,b) => {
          if (sortedColumn.sorted === "asc") {
            return (a[sortedColumn.key] > b[sortedColumn.key]) ? 1 : ((b[sortedColumn.key] > a[sortedColumn.key]) ? -1 : 0);
          } else {
            return (b[sortedColumn.key] > a[sortedColumn.key]) ? 1 : ((a[sortedColumn.key] > b[sortedColumn.key]) ? -1 : 0);
          }
        });
        setRowData(sortedData);
      } else {
        setRowData(data)
      }
    } else {
      setRowData([])
    }
  }, [data, sortedColumn]);

  const onSortingColumn = useCallback(sortColumn => {
    if (!sortedColumn || sortColumn.key !== sortedColumn.key || (sortedColumn.sorted === "desc")) {
      setSortedColumn({...sortColumn, sorted: "asc"});
    } else {
      setSortedColumn({...sortColumn, sorted: "desc"});
    }
  }, [setSortedColumn, sortedColumn]);

  return (
    <div className={`material-ui-table-container ${tableClassName}`} style={{ height: containerHeight ? containerHeight : "20vh", overflow:"auto" }}>
      <Table size="small" aria-label="simple table"  id={tableId} className={`material-ui-table`}>
        <TableHead className="material-ui-table-header" style={{ position: fixedHeader ? "sticky" : "relative", top: 0}}>
          <TableRow className="material-ui-table-header-row">
            {columns && columns.length
              ? columns.map((column) => {
                  return (
                    <TableCell
                      id={`${column.key}`}
                      align={column.align}
                      style={{
                        wordBreak: "keep-all",
                        whiteSpace: "nowrap"
                      }}
                      className={`material-ui-table-header-cell ${column.sort ? "sorting-allowed" : ""}`}
                      onClick={column.sort ? () => onSortingColumn(column) : () => null }
                    >
                      {column.customHeader
                        ? column.customHeader(column)
                        : column.label}
                        {
                          column.sort && sortedColumn && column.key === sortedColumn.key && sortedColumn.sorted === "asc" ? <span className="sort-icons-asc"><BsFillCaretUpFill /></span> : 
                          column.sort && sortedColumn && column.key === sortedColumn.key && sortedColumn.sorted === "desc" ? <span className="sort-icons-desc"><BsFillCaretDownFill /></span> : null 
                        }
                    </TableCell>
                  );
                })
              : null}
          </TableRow>
        </TableHead>
        <TableBody className="material-ui-table-body">
          {columns && columns.length && rowData && rowData.length ? (
            rowData.map((obj) => {
              return (
                <TableRow className="material-ui-table-body-row">
                  {columns.map((column) => {
                    return column.customComponent ? (
                      <TableCell scope="row" align={column.align} className="material-ui-table-body-cell">
                        {column.customComponent(obj, column)}
                      </TableCell>
                    ) : (
                      <TableCell
                        scope="row"
                        align={column.align}
                        className="material-ui-table-body-cell"
                      >
                        {obj[column.key]}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })
          ) : (
            <TableRow className="material-ui-table-body-row">
              <TableCell
                xs={3}
                align="center"
                style={{
                  position: "absolute",
                  paddingLeft: "35%",
                  borderBottom: "none",
                  top: "20%",
                  ...noDataCellCustomStyle
                }}
                className="material-ui-table-body-cell"
              >
                {loading ? "Loading..." : "No Records Found"}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}

export default MaterialUiTable;
